.eq{z-index:50;}